/**
 * @module @/dataFilters/uuid
 */
/**
 * Shorten UUID filter.
 * @example
 * // shows a2dfsdczx
 * {{ 'a2dfsdczx-a2dfsdczx-a2dfsdczx-a2dfsdczx' | uuid }}
 * @example
 * // returns a2dfsdczx
 * this.$options.filters.uuid('a2dfsdczx-a2dfsdczx-a2dfsdczx-a2dfsdczx')
 * @param {string} uuid - The UUID to shorten.
 * @return {string} The short UUID.
 */
export default (uuid) => {
  return uuid.toString().split('-')[0]
}
